export default {
	namespaced: true,
	state: () => ({
		centerIndex: 0,
	}),
	mutations: {
		setCenterIndex(state, data) {
			state.centerIndex = data;
		},
	},
	actions: {},
	getters: {
		centerIndex(state) {
			return state.centerIndex;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Activity/modules/mystery-box-center.js